<template>
  <div class="ima-exhibitions">

    <ima-loading-spinner v-if="exhibitions.isLoading"></ima-loading-spinner>

    <div v-else>
      <h1 class="title">Messen</h1>

      <ima-filter-toolbar :activeFilters="activeFilters">

        <b-field>
          <b-input placeholder="Suchen" type="search" icon="search" v-model="filter.term.value"></b-input>
        </b-field>

        <b-field>
          <b-dropdown @input="(value)=>addFilter('location', value)">
            <button class="button" slot="trigger">
              <b-icon icon="location_on" size="is-small"></b-icon>
              <span>Ort</span>
              <b-icon icon="arrow_drop_down"></b-icon>
            </button>
            <b-dropdown-item v-for="option in options.locations" :value="option" :key="option.id">{{option.label}}</b-dropdown-item>
          </b-dropdown>
        </b-field>

      </ima-filter-toolbar>

      <b-table class="ima-signs-list__table" :data="filteredData" :checked-rows.sync="selected" :striped="true" :checkable="true" :loading="exhibitions.isLoading" :mobile-cards="true" :paginated="true" :per-page="25" :pagination-simple="true" default-sort="['id']">

        <template slot-scope="props">
          <b-table-column field="id" label="ID" sortable numeric>
            {{ props.row.id }}
          </b-table-column>
          <b-table-column field="name" label="Name" sortable>
            {{ props.row.name }}
          </b-table-column>
          <b-table-column field="location" label="Ort" sortable>
            {{ props.row.location || '—'}}
          </b-table-column>

          <b-table-column field="actions" label="Start-Datum" class="nowrap">
            <span v-if="props.row.startDate">{{props.row.startDate | moment('DD.MM.YYYY')}}</span>
            <span v-else>—</span>
          </b-table-column>

          <b-table-column field="actions" label="End-Datum" class="nowrap">
            <span v-if="props.row.endDate">{{props.row.endDate | moment('DD.MM.YYYY')}}</span>
            <span v-else>—</span>
          </b-table-column>

          <b-table-column field="actions" label=" ">
            <div class="control">
              <button v-if="canEditExhibitions" class="button round-button is-primary" type="button" @click="onExhibitionEdit(props.row)">
                <span class="icon">
                  <b-icon icon="mode_edit"></b-icon>
                </span>
              </button>
            </div>
          </b-table-column>

        </template>

        <div slot="empty">
          Keine Schilder verfügbar
        </div>
      </b-table>

      <button v-if="canCreateExhibitions" class="button floating-button" @click="openExhibitionModal()">
        <b-icon icon="add"></b-icon>
      </button>
    </div>

  </div>
</template>

<script>
import { uniqBy, sortBy } from 'lodash'
import { mapState, mapMutations, mapActions } from 'vuex'
import {
  fetchExhibitions,
  selectExhibition,
  unselectExhibition
} from '@/store/modules/exhibitions'
import { openExhibitionModal } from '@/store/modules/modals'
import filterListing from '@/mixins/filter-listing'
import routes from '@/mixins/routes'
import {
  canEditExhibitions,
  canCreateExhibitions
} from '@/services/permissions'
import LoadingSpinner from '@/components/LoadingSpinner'
import FilterToolbar from '@/components/FilterToolbar'

export default {
  name: 'ima-exhibitions',
  components: {
    'ima-loading-spinner': LoadingSpinner,
    'ima-filter-toolbar': FilterToolbar
  },
  mixins: [routes, filterListing],
  data () {
    return {
      filter: {
        term: {
          value: null,
          filter (exhibition) {
            return [exhibition.id, exhibition.name]
              .join()
              .toLowerCase()
              .includes(this.value.toLowerCase())
          }
        },
        location: {
          label: 'Ort',
          values: [],
          filter (exhibition) {
            return this.values
              .map(({ value }) => value)
              .includes(exhibition.location)
          }
        }
      },
      selected: []
    }
  },
  methods: {
    ...mapMutations([
      openExhibitionModal,
      selectExhibition,
      unselectExhibition
    ]),
    ...mapActions([fetchExhibitions]),
    onExhibitionEdit (exhibition) {
      this.selectExhibition(exhibition)
      this.openExhibitionModal()
    }
  },
  computed: {
    ...mapState(['user', 'exhibitions']),
    options () {
      return {
        locations: sortBy(
          uniqBy(
            this.exhibitions.data
              .filter(({ location }) => !!location)
              .map(({ location }) => ({ value: location, label: location })),
            'value'
          ),
          'label'
        )
      }
    },
    filteredData () {
      return this.filterCollection(this.exhibitions.data)
    },
    canEditExhibitions () {
      return canEditExhibitions
    },
    canCreateExhibitions () {
      return canCreateExhibitions
    }
  },
  created () {
    this.fetchExhibitions()
  }
}
</script>

<style lang="scss">
.ima-exhibitions {
}
</style>




// WEBPACK FOOTER //
// src/components/ExhibitionList.vue